module.exports = __webpack_public_path__ + "img/image 1.1a4f4eb0.png";